export class FeaturesController {
	static sceneName(): string | null {
		return this._urlParam('scene');
	}
	static forceSceneSaveCrash(): boolean {
		return this._urlParam('__forceSceneSaveCrash__') == '1';
	}
	static measurePerformanceOnLoad(): boolean {
		return this._urlParam('measurePerformanceOnLoad') == '1';
	}
	static viewerCaptureVideoMbsPerSecond(): number | undefined {
		const numberAsStr = this._urlParam('viewerCaptureVideoMbsPerSecond');
		if (numberAsStr) {
			return parseInt(numberAsStr);
		}
	}
	static displayViewerLogo(): boolean {
		return this._urlParam('displayViewerLogo') == '1';
	}
	static debugErrorsNotifier(): boolean {
		return this._urlParam('debugErrorsNotifier') == '1';
	}
	static noErrorsNotifier(): boolean {
		return this._urlParam('noErrorsNotifier') == '1';
	}

	static createDefinedVariables() {
		// allow the creation of global variables from the url of the editor
		// although a similar functionality can be achieved from EditorConfig (in the local app only)
		const entries = this._urlParams.entries();
		for (let entry of entries) {
			const [entryName, entryValue] = entry;
			const elements = entryName.split('-');
			if (elements[0] == 'polydefine') {
				const varName = elements[1];
				(window as any)[varName] = entryValue;
				console.log(`created global var:${varName}=`, (window as any)[varName]);
			}
		}
	}

	private static _urlParam(param_name: string) {
		return this._urlParams.get(param_name);
	}
	private static _urlParams = new URLSearchParams(window.location.search);
}
